import { Component, OnInit, Input, ViewChild, Output } from '@angular/core';
import { NgForm, AbstractControl } from '@angular/forms';
import { BehaviorSubject } from 'rxjs';
import { CallAPIService } from '../../../services/call-api.service'

import { Routes, Event, Router , RouterModule, ActivatedRoute, NavigationError, NavigationEnd,  NavigationStart } from '@angular/router';
import { RouteChangeNotifierService } from '../../../services/route-change-notifier.service';
//import { PostageInfoService } from './services/postage-info-service';
import { ModalDirective } from 'ngx-bootstrap/modal';



@Component({
  selector: 'find-component',
  templateUrl: './find-post-index.component.html',
  styleUrls: ['./find-post-index.component.sass']
})
export class FindPostIndexComponent implements OnInit {

  @ViewChild('form', {static: true} ) private form : NgForm ;
  public indexSync = new BehaviorSubject( undefined ) 
  public requestForDataPosted = new BehaviorSubject( undefined );
  private postIndex ;
  public indexResponseSubject = new BehaviorSubject( undefined );
  public submitted: boolean = false;
  private startHref : string ;
  public cityValue: any ;
  public streetValue: any ;
  public houseValue: any ;

   @ViewChild('autoShownModal', { static: false }) private autoShownModal: ModalDirective;
  isModalShown = true;

  showModal(): void {
    this.isModalShown = true;
  }

  hideModal(): void {
    this.autoShownModal.hide();
  }

  onHidden(): void {
    this.isModalShown = false;
  }

  constructor(
    private router: Router,
    private activated: ActivatedRoute,
    private calculatorRoute : RouteChangeNotifierService,
    private API : CallAPIService
		//private postageInfoService :PostageInfoService,
	 ) {
  
   // this.startHref = window.location.href ;

    this.router.events.subscribe( (event: Event) => {
		  if (event instanceof NavigationStart) {
        if (  event.url == '/' ) {
          // such if statement means that somewhy path is empty
          // it happens while initialization
          // by default settings is Domestic delivery and package (old Express) postage type
          // so we set default settings while initialization
          calculatorRoute.setRoute( 'find-address' );
        
        }else{
          calculatorRoute.setRoute( event.url.slice(1, event.url.length ) )  // .slice(1, event.url.indexOf("-") )
        
        }
	
		  }
	
		});
	
	}

  ngOnInit() {
    let clearConfig = this.API.buildClearConfig( true, true, true, true, true );
    this.API.executeClearWithConfig( clearConfig );

    /*this.API.getClearSubject().asObservable().subscribe( clear => {
      if( clear != undefined ){
        //this.requestForDataPosted.next( true );

      }

    } )*/

    /*this.form.valueChanges.subscribe( changes => {
      if( changes != undefined ){

      }
    });*/

    this.indexSync.asObservable().subscribe( newIndex => {
      this.postIndex = newIndex ; 
      // console.log(this.postIndex);
    })

    this.indexResponseSubject.asObservable().subscribe( response => {
      if( response ){
        this.scrollTo("indexResponse");
      }
    })
  }

  public saveInputValue( inputName, value ){
    
    switch ( inputName ) {
      case 'city':
        this.cityValue = value;
        break;
      case 'street':
        this.streetValue = value;
        break;
      case 'house':
        this.houseValue = value;
        break;
      default:
        break;
    }

  } 

  submit( form: any ){
    // was 
    //this.API.clearResponses.next( true )
    let contNames = form.controls
    for( let name in contNames ) { 
      if( !form.controls[ name ].value || form.controls[ name ].value && form.controls[ name ].value.length < 1 ){
        
        if( form.controls[ name ].setErrors ){
          form.controls[ name ].setErrors( { emptyInput: true } )
        }
      } 
    } 
    //this.requestForDataPosted.next( true ); 

    if(  this.postIndex && this.postIndex.length == 5 ){ // form.valid &&      //  form.valid ,
      this.API.executeClearWithConfig({ toClearResponse : true })  /// ? del wasnt
      
      this.API.getPostOfficeInfoByIndex( this.postIndex ) //send reques/
      // this.API.getIndexByCityStreetHouse(this.cityValue.CITY_UA, this.streetValue.STREET_UA, this.houseValue.HOUSENUMBER_UA)
    }else{
      ////console.log( 'not valid ', form.errors )
    }

  }

  scrollTo( elementID: string ){
    if( window.innerWidth <= 767 ){
      let interval = setTimeout( function(){
        //console.log( ' SCROLL \n', window.innerWidth );
      
        if( document.getElementById( elementID ) ){
          
          document.getElementById( elementID ).scrollIntoView();
          clearInterval( interval );
        }
          
      } , 50 ) ;
    }
  }

}
